import React, {useState} from "react";
import classes from "./Heading.module.scss";
import erpIcon from '../../media/icons/chart-tree.svg'
import crmIcon from '../../media/icons/headset.svg'
import softwareDevelopmentIcon from '../../media/icons/head-thinking.svg'
import biIcon from '../../media/icons/chart-histogram.svg'
import itConsultingIcon from '../../media/icons/comment.svg'
import {paths} from "./const.ts";
import { ServiceBlock } from "./serviceBlock/ServiceBlock.tsx";
import arrowRight from "../../media/icons/arrow-right-plain.svg";
import {Link} from "react-router";
import { useTranslation } from "react-i18next";


const Heading = () => {
    const [selectedBlockLabel, setSelectedBlockLabel] = useState('ERP');
    const [fade, setFade] = useState(false);
    const { t } = useTranslation();

    const infoCards = [
        {title: '15+', description: t('home.infoCards.years')},
        {title: '200+ ', description: t('home.infoCards.employ')},
        {title: '35+', description: t('home.infoCards.project')},
    ]

    const blocks = [
        { title: t('home.blocks.0.title'), label: 'ERP', icon: erpIcon},
        {title: t('home.blocks.1.title'), label: 'CRM', icon: crmIcon},
        {title: t('home.blocks.2.title'), label: 'Software Development', icon: softwareDevelopmentIcon},
        {title: t('home.blocks.3.title'), label: 'BI Systems', icon: biIcon},
        {title: t('home.blocks.4.title'), label: 'IT Consulting', icon: itConsultingIcon},
    ]

    const handleSelectBlock = (label: string) => {
        setFade(true);
        setTimeout(() => {
            setSelectedBlockLabel(label);
            setFade(false);
        }, 300);
    };

  return (
     <div className={classes["heading-container"]}>
       <div className={classes['two-col']}>
         <div className={`flex gap-42 fl-col-left ${classes['text-block']}`}>
           <h1>{t('home.title')} <span>{t('home.bluetitle')}</span></h1>
             <div className={classes['blocks-1300']}>
                 {blocks.map(block => <ServiceBlock setSelectedBlockLabel={handleSelectBlock} key={block.title} selected={selectedBlockLabel===block.label} title={block.title} label={block.label} icon={block.icon}/>)}
             </div>
             <p className={`${fade ? classes.fadeOut : classes.fadeIn}`}>
                 {t('home.' + selectedBlockLabel.replaceAll(" ", ""))}
             </p>
             <Link to={paths[selectedBlockLabel]} className='learn-more-button'>
                 <span>{t('buttons.learnMore')}</span>
                 <img src={arrowRight} alt='arrow right'/>
           </Link>
         </div>

         <div className={`grid-3 gap-16 ${classes.blocks}`}>
             {blocks.map(block => <ServiceBlock setSelectedBlockLabel={handleSelectBlock} key={block.label} selected={selectedBlockLabel===block.label} title={block.title} label={block.label} icon={block.icon}/>)}
         </div>
       </div>
       <div className={classes['info-blocks-container']}>
           {infoCards.map((infoCard) => <div key={infoCard.title} className={classes['info-block']}>
               <h3>{infoCard.title}</h3>
               <p>{infoCard.description}</p>
           </div>)}
       </div>
     </div>
  );
};

export default Heading;
